import React from 'react';
import { Segment, Header, Sidebar, Image, Container, Divider, Table, Dimmer, Label, Loader, Breadcrumb, Icon,Menu, Checkbox, Button, Input, Pagination} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import TagRow from './TagRow';


const TagList=({tag, ajaxCallInProgress, onShowModalActivar, onShowModalBorrar, activePage, totalPages, handleSelectPagination , color={}, form, permisos, showActivos, handleChangeActivos, handleChangeFiltro, filtro, onFiltrarInformacion, filtroActual, filtroActivo, onDesactivarFiltro, strings, usuarioActual})=>{

    return (
    <Container>
   <Dimmer.Dimmable   dimmed={ajaxCallInProgress>0?true:false}>
        
        <Segment basic>
          
		 
        <Header as='h2'  dividing>
             {strings?strings["Tag"]:""} 
          </Header>
	       <Dimmer active={ajaxCallInProgress>0?true:false} className="app"  inverted>
                <Loader size='big'  content={strings?strings["Procesando"]:""}/>
          </Dimmer>
 
            <Menu  size="mini" >
                <Menu.Item>
                      <Header as='h3'>
                         {strings?strings["acciones"]:""}: 
                      </Header>
                </Menu.Item>
				  
                <Menu.Item>
                    <Link to="/tag">
                      <Button color={color.button}>
                          {strings?strings["nuevo"]:""}
                        </Button>
                    </Link>
                </Menu.Item>
                 
                
                <Menu.Item >
                   <Checkbox slider size="mini" checked={showActivos}  onClick={handleChangeActivos} label={strings?strings["factivos"]:""}/>
                </Menu.Item>
                <Menu.Item position='right'>
                   <Input   onChange={handleChangeFiltro} value={filtro} 
                        action={{ type: 'button',   color:color.button, icon: 'search', onClick:onFiltrarInformacion}} 
                    placeholder={strings?strings["buscar"]:""} />
                </Menu.Item>
          </Menu>
           {filtroActivo?
                <Label link onClick={onDesactivarFiltro} color='yellow'  >
                        Filtro activo: {filtroActual} <Icon name='close' /> 
                      </Label>
            : ""}
                <Table  celled >
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell textAlign="center">{strings?strings["Tag"]:""}</Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">{strings?strings["estatus"]:""}</Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">{strings?strings["accion"]:""}</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {tag.map(renglon =>
								<TagRow 
                                   onShowModalActivar={onShowModalActivar}
									key={renglon.id} 
									tag={renglon} 	
                                   onShowModalBorrar={onShowModalBorrar}
									color={color}
									form={form}
									permisos={permisos}
									/>
				        )}	
                    </Table.Body>
                  </Table> 
         
    
        <Segment attached="bottom"   centered >
            <Pagination	totalPages={totalPages}
              				activePage={activePage}
							onPageChange={handleSelectPagination}
				/>
        </Segment>

        </Segment>
        </Dimmer.Dimmable>
</Container>
	);
};



export default TagList;